import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-text-image-redesign',
    templateUrl: './text-image-redesign.component.html',
    styleUrls: ['./text-image-redesign.component.scss']
})
export class TextImageRedesignComponent {

    @Input() paragraphs: string[] = [];

    @Input() image = '';

    @Input() imageAlt = '';

    trackByIndex(index: number): number {
        return index;
    }

}